import React, {
  FunctionComponent, useCallback, useEffect, useState,
} from 'react';
import { useDebounceCallback } from '@react-hook/debounce';
import { Button } from '../v2';
import { convertV2ConditionToV1Ui } from '../policy/util';
import Tab from './v2/tab';

export interface SimpleButtonProps {
  condition: string;
  onClick: () => void;
  isComplexConditionEditor: boolean;
}

const SimpleButton: FunctionComponent<SimpleButtonProps> = ({
  condition, onClick, isComplexConditionEditor,
}: SimpleButtonProps) => {
  const [isValid, setValid] = useState<boolean>(false);

  const validityCheck = useCallback((cond: string) => {
    try {
      convertV2ConditionToV1Ui(cond);
      setValid(true);
    } catch (err) {
      setValid(false);
    }
  }, []);

  const debouncedValidityCheck = useDebounceCallback(
    validityCheck, 250, true,
  );

  useEffect(() => {
    debouncedValidityCheck(condition);
  }, [condition, debouncedValidityCheck]);

  return (
    // TODO: check if we can use isValid to disable the tab?
    <Tab active={!isComplexConditionEditor} onClick={onClick}>
      Select Attribute
    </Tab>
  );
};

export default SimpleButton;
